<template>
    <footer class="app-footer">
        &copy; {{date}} LeadGroup. 
        <span class="float-right" style="padding-left:10px;"><b>{{ $t('statistic.last_version') }}:</b>
          <span><router-link :to="'/pages/versions'">{{ lastVersion }}</router-link></span> 
        </span>
        <span class="float-right"><b>{{ $t('statistic.last_update') }}:</b>
          <span v-if="Storage.developMode"><router-link :to="'/pages/changelog'">{{ lastUpdate }}</router-link></span> 
          <span v-else>{{ lastUpdate }}</span>
        </span>
    </footer>
</template>
<script>
  import Config from '@/Config'
  // import Auth from '@/api/Auth'
  import Storage from '@/api/Storage'

  export default {
    name: 'footer',
    data () {
      return {
        Config: Config,
        Storage: Storage,
        lastUpdate: Storage.lastUpdate,
        lastVersion: Storage.lastVersion,
        date: new Date().getFullYear()
      }
    }
  }
</script>



// WEBPACK FOOTER //
// Footer.vue?5bb941e3